import React, { useState } from "react";
import { Box, Button } from '@mui/material';
import sendRequest from '../utils/sendRequest';
import { ButtonSpinnerBlue } from "../styled/CustomSpinners";

export default function WorksheetAutomationButton({ po_doc_id, addSnackbar, closeMoreActions }) {
  const [loadingAuto, setLoadingAuto] = useState(false);

  const runAutomations = async () => {
    setLoadingAuto(true);
    try {
      let response = await sendRequest(`purchase-orders/run-worksheet-automations?po_doc_id=${po_doc_id}`);
      addSnackbar(response.message);
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      setLoadingAuto(false);
      closeMoreActions();
    }
  }

  return (
    <Box>
        <Button variant="text" onClick={runAutomations}>
            {loadingAuto ? <ButtonSpinnerBlue /> : "Run Worksheet Automations"}
        </Button>
    </Box>
  )
}